import React from "react";
//#region types
import { MoreActionMenuItem } from "models/propTypes/menuPropTypes";
import { CostForwarding, CostForwardingSource } from "models/utilTypes/costForwardingTypes";
//#endregion

export interface CostForwardingMarkingContextValue {
  marking?: CostForwarding;
  isAvailable: boolean;
  reload: () => void;
  source?: CostForwardingSource;
  sourceId?: number;
  supplierName?: string;
  editAction?: MoreActionMenuItem;
}

// A context rather than a prop because the form sections sit several generic form layers below the
// container that loads the marking, and those layers' prop types live in models/, which does not
// import from components/.
const CostForwardingMarkingContext = React.createContext<CostForwardingMarkingContextValue>({
  isAvailable: false,
  reload: () => {},
});

export const CostForwardingMarkingProvider = CostForwardingMarkingContext.Provider;

export const useCostForwardingMarkingContext = () => React.useContext(CostForwardingMarkingContext);
